import React from "react";
import { useLocation } from "react-router-dom";
import "./More.css";

const More = () => {
  const location = useLocation();
  const iframeUrl = location.state?.url;

  return (
    <div className="more-page">
      {iframeUrl ? (
        <iframe
          src={iframeUrl}
          className="more-iframe"
          title="More Content"
          allowFullScreen
          allow="microphone"
          sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox"
        />
      ) : (
        <div className="more-placeholder">More Page (Coming Soon)</div>
      )}
    </div>
  );
};

export default More;
